// removed by extract-text-webpack-plugin
module.exports = {"confirmForgotPass":"ConfirmForgotPass__confirmForgotPass","message":"ConfirmForgotPass__message","growDotQello":"ConfirmForgotPass__growDotQello","growDotBlue":"ConfirmForgotPass__growDotBlue","growDotGolden":"ConfirmForgotPass__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConfirmForgotPass/ConfirmForgotPass.scss
// module id = 1898
// module chunks = 0